import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {OccasionBrandsQuery} from '../../gql/pwa/graphql';
import {Occasions} from '../../network/occasions';

interface State extends OccasionBrandsQuery {}

export const fetchOccasionBrands = createAsyncThunk('occasionBrands/fetchOccasionBrands', async () => {
    const result = await Occasions.getOccasionBrands();
    return result.data;
});

export const occasionBrandsSlice = createSlice({
    name: 'occasionBrands',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchOccasionBrands.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(fetchOccasionBrands.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.occasionBrands = action.payload.occasionBrands;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(fetchOccasionBrands.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
